export default __webpack_public_path__ + "static/stream-c2fcef0fbc945fb1ca1607d81e39707d.png";